module.exports = __webpack_public_path__ + "static/media/E20.1f1fcba2.png";